import { derived } from 'svelte/store'

import { facultyOneYear, facultyTotal, staffFaculty, staffGender } from '../dataPromisesMenu'

import fetchStore from '../utilities/fetchStore'

const regex = /\$|\,/g

export default function () {
  // build our object of data calls for the home page (we imported the ones we need from the 'menu' above)
  const dataCalls = {
    facultyOneYear: facultyOneYear,
    facultyTotal: facultyTotal,
    staffFaculty: staffFaculty,
    staffGender: staffGender,
  }
  
  const [data, loading, error] = fetchStore(dataCalls)

  const facultyOneYearDerived = derived(data, ($data)=>{
    if($data.facultyOneYear) {
      return  Number(Object.values($data.facultyOneYear)[0].replace(',',''))
    } else {
      return 0
    }
  }, 0)

  const facultyTotalDerived = derived(data, ($data)=>{
    if($data.facultyTotal) {
      const entries = Object.entries($data.facultyTotal)
      const itemsArray = entries.map((obj)=>{
        return {label:obj[0], value:obj[1]}
      })
      return itemsArray
    } else {
      return []
    }
  }, [])

  const staffGenderDerived = derived(data, ($data)=>{
    if($data.staffGender) {
      console.log('staffGender from Storefunc',Object.entries($data.staffGender))
      return Object.entries($data.staffGender)
    } else {
      return []
    }
  }, [])

  const staffFacultyDerived = derived(data, ($data)=>{
    if($data.staffFaculty) {
      return Object.entries($data.staffFaculty)
    } else {
      return []
    }
  }, [])
  
  return [
    data, 
    loading, 
    error,

    facultyOneYearDerived,
    facultyTotalDerived,
    staffFacultyDerived,
    staffGenderDerived,
  ]
}